<template>
  <div class="upload-attachment">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.section.uploadAttachment") }}</legend>
    </fieldset>
    <div class="info-group">
      <div class="form-group" :class="{'has-error': certificateOfIncorporationStatus, 'valid': certificateOfIncorporationStatus}">
        <label for="CertificateOfIncorporation"
               class="control-label upload-label app-logo-label-kyc">Certificate of Incorporation：</label>
        <div class="app-logo-wrapper-kyc">
          <!-- :file-types="'.png, .jpg, .jpeg, .gif'" -->
          <vuestic-file-upload-kyc id="CertificateOfIncorporation"
                                   type="list"
                                   v-model="uploadAttachment.certificateOfIncorporation"
                                   ref="fieldInput"
                                   @input="uploadFile(arguments[0], 'certificateOfIncorporation')"
                                   @removeFile="removeFile(arguments[0], 'certificateOfIncorporation')"
                                   :disabled="kycStatus=== 'submitted'?true:false" />
          <small v-show="certificateOfIncorporationStatus"
                   class="help text-danger">{{ $t("kyc.theCertificateOfIncorporationFieldIsRequired") }}</small>
        </div>
      </div>
    </div>

    <div class="info-group" v-if="isHK">
      <div class="form-group" :class="{'has-error': businessRegistrationStatus, 'valid': businessRegistrationStatus}">
        <label for="businessRegistration"
               class="control-label upload-label app-logo-label-kyc">{{ $t("kyc.businessRegistration") }}<br />(Mandatory for HK Company)：</label>
        <div class="app-logo-wrapper-kyc">
          <!-- :file-types="'.png, .jpg, .jpeg, .gif'" -->
          <vuestic-file-upload-kyc id="businessRegistration"
                                   type="list"
                                   v-model="uploadAttachment.businessRegistration"
                                   ref="fieldInput"
                                   @input="uploadFile(arguments[0], 'businessRegistration')"
                                   @removeFile="removeFile(arguments[0], 'businessRegistration')"
                                   :disabled="kycStatus=== 'submitted'?true:false" />
          <small v-show="businessRegistrationStatus"
                   class="help text-danger">{{ $t("kyc.theBusinessRegistrationFieldIsRequired") }}</small>
        </div>
      </div>
    </div>

    <div class="info-group" v-if="isHK">
      <div class="form-group" :class="{'has-error': nar1Status, 'valid': nar1Status}">
        <label for="nar1"
               class="control-label upload-label app-logo-label-kyc">{{ $t("kyc.nar1") }}<br />(Mandatory for HK Company)：</label>
        <div class="app-logo-wrapper-kyc">
          <!-- :file-types="'.png, .jpg, .jpeg, .gif'" -->
          <vuestic-file-upload-kyc id="nar1"
                                   type="list"
                                   v-model="uploadAttachment.nar1"
                                   ref="fieldInput"
                                   @input="uploadFile(arguments[0], 'nar1')"
                                   @removeFile="removeFile(arguments[0], 'nar1')"
                                   :disabled="kycStatus=== 'submitted'?true:false" />
          <small v-show="nar1Status"
                   class="help text-danger">{{ $t("kyc.theNar1FieldIsRequired") }}</small>
        </div>
      </div>
    </div>

    <div class="info-group">
      <div class="form-group" :class="{'has-error': articlesOfAssociationStatus, 'valid': articlesOfAssociationStatus}">
        <label for="articlesOfAssociation"
               class="control-label upload-label app-logo-label-kyc">{{kycStatus=== 'firstEdit'?'Articles of Association：':'Memodumum & Articles of Association：'}}</label>
        <div class="app-logo-wrapper-kyc">
          <!-- :file-types="'.png, .jpg, .jpeg, .gif'" -->
          <vuestic-file-upload-kyc id="articlesOfAssociation"
                                   type="list"
                                   v-model="uploadAttachment.articlesOfAssociation"
                                   ref="fieldInput"
                                   @input="uploadFile(arguments[0], 'articlesOfAssociation')"
                                   @removeFile="removeFile(arguments[0], 'articlesOfAssociation')"
                                   :disabled="kycStatus=== 'submitted'?true:false" />
          <small v-show="articlesOfAssociationStatus"
                   class="help text-danger">{{ $t("kyc.theArticlesOfAssociationFieldIsRequired") }}</small>
        </div>
      </div>
    </div>

    <div class="info-group">
      <div class="form-group aml-question-group" :class="{'has-error': amlQuestionnaireStatus, 'valid': amlQuestionnaireStatus}">
        <label for="amlQuestionnaire"
               class="control-label upload-label app-logo-label-kyc">AML Questionnaire：</label>
        <div class="app-logo-wrapper-kyc">
          <vuestic-file-upload-kyc id="amlQuestionnaire"
                                   type="list"
                                   v-model="uploadAttachment.amlQuestionnaire"
                                   ref="fieldInput"
                                   @input="uploadFile(arguments[0], 'amlQuestionnaire')"
                                   @removeFile="removeFile(arguments[0], 'amlQuestionnaire')"
                                   :disabled="kycStatus=== 'submitted'?true:false" />
          <small v-show="amlQuestionnaireStatus"
                   class="help text-danger">{{ $t("kyc.theAmlQuestionnaireFieldIsRequired") }}</small>
        </div>
        <div>
          <button type="button"
                  @click="downloadTemplate"
                  class="btn btn-info btn-micro aml-question-btn"
                  :disabled="kycStatus=== 'submitted'?true:false">
                  <b-icon-download class="mr-1" />
                  <span class="align-middle">{{ $t("basic.button.template") }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
// .pdf
// .jpg/.jpeg/.jpe/.png
// .doc/.docx
// .xls/.xlsx
import vuesticFileUploadKyc from '../../../vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUpload'
import mixin from '../mixins/mixin'
export default {
  mixins: [mixin],
  props: {
    kycStatus: {
      type: String,
      default: '',
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      isHK: false,
      uploadAttachment: {
        certificateOfIncorporation: '',
        businessRegistration: '',
        nar1: '',
        articlesOfAssociation: '',
        amlQuestionnaire: [],
      },
      certificateOfIncorporationStatus: false,
      businessRegistrationStatus: false,
      nar1Status: false,
      articlesOfAssociationStatus: false,
      amlQuestionnaireStatus: false,
    }
  },
  mounted () {
    let that = this
    if (that.kycStatus === 'firstEdit') {
      that.getMerchantKYCInfo(3, res => {
        that.isHK = res.is_registered_country_or_region_hk
        that.setUploadAttachInfo(res.upload_attachment_info)
      })
    } else {
      if (that.merchantData.base_info) {
        that.isHK = that.merchantData.is_registered_country_or_region_hk
      }
      if (that.merchantData.upload_attachment_info) {
        that.setUploadAttachInfo(that.merchantData.upload_attachment_info)
      }
    }
  },
  computed: {},
  methods: {
    setUploadAttachInfo (info) {
      if (!info) return
      this.uploadAttachment.certificateOfIncorporation = info.certificate_of_incorporation_file_list
      this.uploadAttachment.businessRegistration = info.business_registration_file_list
      this.uploadAttachment.nar1 = info.nar1_file_list
      this.uploadAttachment.articlesOfAssociation = info.articles_of_association_list
      this.uploadAttachment.amlQuestionnaire = info.aml_questionnaire_list
    },
    uploadFile (image, type) {
      let curArray = this.uploadAttachment[type]
      if (curArray && curArray.length > 0) {
        this.changeStatusByType(type, false)
      }
    },
    removeFile (file, type) {
      try {
        let curArray = this.uploadAttachment[type]
        if (curArray && curArray.length > 0) {
          curArray = curArray.filter(image => {
            return file !== image
          })
          if (curArray.length === 0) {
            this.changeStatusByType(type, true)
          }
        }
      } catch (error) {}
    },
    saveUploadAttachment (cb) {
      let that = this
      if (that.checkUploadAttachment()) {
        let params = {
          page: 3,
          upload_attachment_info: {
            certificate_of_incorporation_file_list: that.uploadAttachment.certificateOfIncorporation,
            articles_of_association_list: that.uploadAttachment.articlesOfAssociation,
            aml_questionnaire_list: that.uploadAttachment.amlQuestionnaire,
          }
        }
        if (that.isHK) {
          params.upload_attachment_info.business_registration_file_list = that.uploadAttachment.businessRegistration
          params.upload_attachment_info.nar1_file_list = that.uploadAttachment.nar1
        }
        that.$emit('updateKycInformation', params, function () {
          let flag = true
          cb(flag)
        })
      } else {
        that.$message({
          type: 'warn',
          message: 'Please check the information you uploaded'
        })
      }
    },
    getUploadAttachment (cb) {
      let that = this
      let uploadAttachment = new Promise((resolve, reject) => {
        if (that.checkUploadAttachment()) {
          let params = {
            upload_attachment_info: {
              certificate_of_incorporation_file_list: that.uploadAttachment.certificateOfIncorporation,
              articles_of_association_list: that.uploadAttachment.articlesOfAssociation,
              aml_questionnaire_list: that.uploadAttachment.amlQuestionnaire,
            }
          }
          if (that.isHK) {
            params.upload_attachment_info.business_registration_file_list = that.uploadAttachment.businessRegistration
            params.upload_attachment_info.nar1_file_list = that.uploadAttachment.nar1
          }
          resolve(params)
        } else {
          that.$message({
            type: 'warn',
            message: 'Please check the information you uploaded'
          })
        }
      })
      return uploadAttachment
    },
    changeStatusByType (type, flag) {
      try {
        this[type + 'Status'] = flag
      } catch (error) {}
    },
    checkUploadAttachment () {
      let uploadAttachment
      // 'amlQuestionnaire'
      if (this.isHK) {
        uploadAttachment = [ 'certificateOfIncorporation', 'businessRegistration', 'nar1', 'articlesOfAssociation' ]
      } else {
        uploadAttachment = [ 'certificateOfIncorporation', 'articlesOfAssociation' ]
      }
      let isValidate = uploadAttachment.reduce((result, current) => {
        if (!this.uploadAttachment[current] || this.uploadAttachment[current].length === 0) {
          this[current + 'Status'] = true
        } else {
          this[current + 'Status'] = false
        }
        return result && !this[current + 'Status']
      }, true)
      return isValidate
    },
    downloadTemplate () {
      var aFile = document.createElement('a')
      var envName = process.env.VUE_APP_NAME.toLowerCase()
      aFile.href = `https://res.${envName}.com/test/kyc/AML_Template.docx`
      aFile.download = 'AML_Template.docx'
      aFile.style.display = 'none'
      document.body.appendChild(aFile)
      aFile.click()
      aFile.remove()
    },
    unique (arr) {
      if (!Array.isArray(arr)) {
        console.log('type error!')
        return
      }
      var array = []
      for (var i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) === -1) {
          array.push(arr[i])
        }
      }
      return array
    },
  },
  components: {
    vuesticFileUploadKyc,
  },
}
</script>
<style lang="scss" scoped>
.upload-attachment {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }
  /deep/ .upload-label {
    position: inherit;
  }
  /deep/ .app-logo-label-kyc {
    // width: 105px;
    white-space: nowrap;
    text-overflow: inherit;
    min-width: 33%;
  }
  /deep/ .app-logo-wrapper-kyc {
    white-space: nowrap;
    text-overflow: inherit;
    overflow: inherit;
    width: 67%;
  }
  .aml-question-group {
    position: relative;
    .aml-question-btn {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
